import type { NavigateFunction } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';

type NavigateToChatParams = {
  navigate: NavigateFunction;
  organizationId: string | number;
  documentId?: string;
  /** Сохранять session_id при навигации (по умолчанию true) */
  preserveSession?: boolean;
};

/**
 * Навигация к чату с опциональным сохранением session_id
 */
export const navigateToChatWithSession = ({
  navigate,
  organizationId,
  documentId,
  preserveSession = true,
}: NavigateToChatParams): void => {
  const basePath = documentId
    ? ROUTES.organization.documents.chat.create(String(organizationId), documentId)
    : ROUTES.organization.documents.chat.create(String(organizationId));

  if (preserveSession) {
    // Читаем session_id напрямую из URL
    const currentParams = new URLSearchParams(window.location.search);
    const sessionId = currentParams.get('session_id');

    if (sessionId) {
      const params = new URLSearchParams();

      params.set('session_id', sessionId);
      navigate(`${basePath}?${params.toString()}`);

      return;
    }
  }

  navigate(basePath);
};
